import { render, staticRenderFns } from "./ProjectDownloads.vue?vue&type=template&id=5b31c6c3&"
import script from "./ProjectDownloads.vue?vue&type=script&lang=js&"
export * from "./ProjectDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports